module.exports = __webpack_public_path__ + "static/media/3world.be7685a3.gif";